// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb20: FC<LightBulb20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.996 18c-.414 0-.767-.147-1.059-.44A1.45 1.45 0 0 1 8.5 16.5h3c0 .417-.147.77-.442 1.063A1.456 1.456 0 0 1 9.996 18ZM7 15.5V14h6v1.5H7ZM6.687 13a5.355 5.355 0 0 1-1.99-2.135A6.127 6.127 0 0 1 4 8c0-1.667.583-3.083 1.75-4.25C6.917 2.583 8.333 2 10 2c1.667 0 3.083.583 4.25 1.75C15.417 4.917 16 6.333 16 8a6.127 6.127 0 0 1-.698 2.865A5.355 5.355 0 0 1 13.312 13H6.689Zm.48-1.5h5.666a4.49 4.49 0 0 0 1.23-1.563A4.442 4.442 0 0 0 14.5 8c0-1.255-.436-2.318-1.308-3.19-.872-.874-1.934-1.31-3.187-1.31s-2.318.436-3.193 1.31C5.938 5.681 5.5 6.744 5.5 8c0 .68.146 1.326.438 1.938A4.489 4.489 0 0 0 7.167 11.5Z" />
        </svg>
    );
};

export default LightBulb20;
